(function () {
  if (window.__vsCartMaxReady) return;
  window.__vsCartMaxReady = true;

  var integrityState = {
    maxPricePromise: null
  };

  function ensureBundleServerGuard() {
    var html = document.documentElement;
    html.setAttribute('data-vs-bundle-server-ready', 'false');
    html.removeAttribute('data-vs-bundle-mode');

    try {
      sessionStorage.removeItem('vsBundleMode');
      sessionStorage.removeItem('vsBundleDismissed');
    } catch (error) {}

    if (!document.getElementById('VSBundleServerGuardStyles')) {
      var style = document.createElement('style');
      style.id = 'VSBundleServerGuardStyles';
      style.textContent =
        'html[data-vs-bundle-server-ready="false"] .vs-bundle-companion,' +
        'html[data-vs-bundle-server-ready="false"] [data-vs-bundle-start],' +
        'html[data-vs-bundle-server-ready="false"] [data-vs-bundle-add],' +
        'html[data-vs-bundle-server-ready="false"] [data-vs-bundle-transition],' +
        'html[data-vs-bundle-server-ready="false"] .vsc-set{display:none!important;}';
      (document.head || document.documentElement).appendChild(style);
    }
  }

  function removeStrayProductBrace() {
    document.querySelectorAll('[id^="VSP-"]').forEach(function (root) {
      var section = root.closest('.shopify-section') || root.parentElement;
      if (!section) return;

      Array.from(section.childNodes).forEach(function (node) {
        if (node.nodeType === 3 && String(node.textContent || '').trim() === '{') {
          node.remove();
        }
      });
    });
  }

  function scrubAmbiguousJeansSize() {
    document.querySelectorAll('[data-vsj]').forEach(function (root) {
      root.querySelectorAll('.vsj__quick-item').forEach(function (item) {
        var label = item.querySelector('span');
        var value = item.querySelector('strong');
        if (!label || !value) return;

        if (
          label.textContent.trim().toUpperCase() === 'ROZMIAR' &&
          value.textContent.trim().toLowerCase() === 'default title'
        ) {
          value.textContent = '—';
        }
      });

      root.querySelectorAll('.vsj__accordion-content p').forEach(function (paragraph) {
        var normalized = paragraph.textContent.trim().toLowerCase().replace(/\s+/g, ' ');
        if (normalized !== 'rozmiar: default title') return;

        var strong = document.createElement('strong');
        strong.textContent = 'Rozmiar:';
        paragraph.replaceChildren(strong, document.createTextNode(' —'));
      });
    });
  }

  function formatPln(cents) {
    try {
      return new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency: 'PLN'
      }).format(Number(cents) / 100);
    } catch (error) {
      return (Number(cents) / 100).toFixed(2).replace('.', ',') + ' zł';
    }
  }

  function currentJeansMaxPriceTarget() {
    return document.querySelector('[data-vsj] .vsj__max-heading > b');
  }

  function syncJeansMaxPrice() {
    var target = currentJeansMaxPriceTarget();
    if (!target) return Promise.resolve();

    // Fail closed: never leave the old hardcoded 19,99 zł visible while the
    // real product price is being verified from Shopify.
    target.hidden = true;

    if (!integrityState.maxPricePromise) {
      var shopRoot =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      integrityState.maxPricePromise = fetch(shopRoot + 'products/vintage-protect-max.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Protect MAX price lookup failed');
          return response.json();
        })
        .then(function (product) {
          var variants = product && Array.isArray(product.variants) ? product.variants : [];
          var variant = variants.find(function (item) { return item.available; }) || variants[0];
          var cents = Number(variant && variant.price);
          if (!Number.isFinite(cents) || cents < 0) throw new Error('Protect MAX price is invalid');
          return formatPln(cents);
        })
        .finally(function () {
          integrityState.maxPricePromise = null;
        });
    }

    return integrityState.maxPricePromise
      .then(function (priceText) {
        var currentTarget = currentJeansMaxPriceTarget();
        if (!currentTarget || !priceText) return;
        currentTarget.textContent = '+' + priceText;
        currentTarget.hidden = false;
      })
      .catch(function (error) {
        console.warn('Vintage Szafa Protect MAX price sync failed', error);
      });
  }

  function applyIntegrityGuards() {
    ensureBundleServerGuard();
    removeStrayProductBrace();
    scrubAmbiguousJeansSize();
    syncJeansMaxPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyIntegrityGuards, { once: true });
  } else {
    applyIntegrityGuards();
  }

  window.addEventListener('pageshow', applyIntegrityGuards);
  document.addEventListener('shopify:section:load', applyIntegrityGuards);

  function cartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (component) { return component.dataset.sectionId; })
      .filter(Boolean)
      .filter(function (id, index, ids) { return ids.indexOf(id) === index; });
  }

  function cartFetch(url, options) {
    if (window.VSCartMutation && typeof window.VSCartMutation.request === 'function') {
      return window.VSCartMutation.request(url, options);
    }
    return window.fetch(url, options);
  }

  function visibleItemCount(cart, maxVariantId) {
    return (cart.items || []).reduce(function (total, item) {
      var properties = item.properties || {};
      var isMax =
        item.handle === 'vintage-protect-max' ||
        item.product_handle === 'vintage-protect-max' ||
        properties._vs_addon === 'Vintage Protect MAX' ||
        Number(item.variant_id) === Number(maxVariantId);
      return total + (isMax ? 0 : Number(item.quantity || 0));
    }, 0);
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-vs-cart-max-toggle]');
    if (!button) return;

    event.preventDefault();

    var label = button.querySelector('[data-vs-max-label]');
    var errorBox = button.closest('[data-vs-cart-max]')?.querySelector('[data-vs-max-error]');
    var isActive = button.dataset.active === 'true';
    var variantId = Number(button.dataset.variantId);
    var shopRoot =
      window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

    // begin() wyłącza wszystkie kontrolki koszyka, również kliknięty
    // przycisk, więc jego stan trzeba sprawdzić przed blokadą globalną.
    if (button.disabled || !Number.isFinite(variantId) || variantId <= 0) return;

    var mutationController = window.VSCartMutation;
    if (mutationController) {
      if (!mutationController.begin('drawer-max')) return;
    } else {
      if (window.__vsCartMutationInFlight) return;
      window.__vsCartMutationInFlight = true;
    }

    button.disabled = true;
    button.classList.add('is-loading');
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    if (label) label.textContent = isActive ? 'USUWAM…' : 'DODAJĘ…';

    try {
      var sectionIds = cartSectionIds();
      var commonPayload = {
        sections: sectionIds.join(','),
        sections_url: window.location.pathname + window.location.search
      };

      var currentResponse = await cartFetch(shopRoot + 'cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin'
      });
      if (!currentResponse.ok) throw new Error('Cart refresh failed');
      var currentCart = await currentResponse.json();
      if (!currentCart || !Array.isArray(currentCart.items)) throw new Error('Nie udało się odczytać koszyka.');
      if (!isActive && visibleItemCount(currentCart, variantId) === 0) {
        throw new Error('Najpierw dodaj rzecz do koszyka. Ochrona jest dodatkiem do zamówienia.');
      }
      var maxLines = (currentCart.items || []).filter(function (item) {
        var properties = item.properties || {};
        return (
          item.handle === 'vintage-protect-max' ||
          item.product_handle === 'vintage-protect-max' ||
          properties._vs_addon === 'Vintage Protect MAX' ||
          Number(item.variant_id) === variantId
        );
      });

      var requestPath;
      var requestBody;
      if (isActive || maxLines.length) {
        var updates = {};
        maxLines.forEach(function (item, index) {
          updates[item.key] = isActive ? 0 : (index === 0 ? 1 : 0);
        });
        requestPath = 'cart/update.js';
        requestBody = Object.assign({}, commonPayload, { updates: updates });
      } else {
        requestPath = 'cart/add.js';
        requestBody = Object.assign({}, commonPayload, {
          items: [{
            id: variantId,
            quantity: 1,
            properties: { _vs_addon: 'Vintage Protect MAX' }
          }]
        });
      }

      var response = await cartFetch(
        shopRoot + requestPath,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(requestBody)
        }
      );

      var responseData = await response.json();
      if (!response.ok || responseData.errors || responseData.status) {
        throw new Error(responseData.description || responseData.message || 'Cart update failed');
      }

      var cartResponse = await cartFetch(shopRoot + 'cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin'
      });
      if (!cartResponse.ok) throw new Error('Cart refresh failed');
      var cartData = await cartResponse.json();
      if (!cartData || !Array.isArray(cartData.items)) throw new Error('Nie udało się odczytać koszyka.');
      var displayCount = visibleItemCount(cartData, variantId);

      try { sessionStorage.removeItem('cart-count'); } catch (error) {}

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cartData,
          sourceId: 'vs-protect-max',
          data: {
            itemCount: displayCount,
            visibleItemCount: displayCount,
            source: 'vs-protect-max',
            sections: responseData.sections || {}
          }
        }
      }));

      window.dispatchEvent(
        new CustomEvent('vs:max-updated', {
          detail: {
            active: !isActive,
            cart: cartData
          }
        })
      );
    } catch (error) {
      if (errorBox) {
        errorBox.hidden = false;
        errorBox.textContent = error.message?.startsWith('Najpierw dodaj')
          ? error.message
          : 'Nie udało się potwierdzić zmiany. Sprawdź połączenie i spróbuj ponownie.';
      }
      if (label) {
        label.textContent = 'SPRÓBUJ PONOWNIE';
      }
      window.VSCRO?.track('ui_error', {
        component: 'protect_max',
        error_code: 'cart_update_failed',
        action: isActive ? 'remove' : 'add'
      });
    } finally {
      if (mutationController) mutationController.end('drawer-max');
      else window.__vsCartMutationInFlight = false;
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  });
})();
